import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type ModuleName = 'Inspection-templates' | 'Projects' | 'Sites' | 'Assets' | 'Templates' | 'Orders' | 'Schedule'

type TabState = {
  [key in ModuleName]: number
}

const initialState: TabState = {
  'Inspection-templates': 0,
  'Projects': 0,
  'Sites': 0,
  'Assets': 0,
  'Templates': 0,
  'Orders': 0,
  'Schedule': 0
}

export const TabSlices = createSlice({
  name: 'tabs',
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<{ module: ModuleName; index: number }>) => {
      const { module, index } = action.payload
      state[module] = index
    },
  },
})

export const { setActiveTab } = TabSlices.actions
export default TabSlices.reducer
